import { Observable } from 'rxjs';

/**
 * Error categories for organized error handling
 */
export enum EsriErrorType {
  ABORT = 'AbortError',
  NETWORK = 'NetworkError',
  TIMEOUT = 'TimeoutError',
  AUTHENTICATION = 'AuthenticationError',
  UNKNOWN = 'UnknownError'
}

/**
 * Interface representing an Esri request error
 */
export interface EsriRequestError {
  name: string;
  message: string;
  errorType?: EsriErrorType;
  details?: {
    httpStatus?: number;
    url?: string;
    [key: string]: any;
  };
  url?: string;
  request?: {
    url?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

/**
 * Type definition for error handler functions
 */
export type EsriErrorHandler = (
  error: EsriRequestError
) => Observable<EsriRequestError>;

/**
 * Configuration options for error handlers
 */
export interface ErrorHandlerOptions {
  /** Apply debounce to this error handler (in ms) */
  debounceTime?: number;
  /** Include errors matching these types */
  includeErrorTypes?: EsriErrorType[];
  /** Exclude errors matching these types */
  excludeErrorTypes?: EsriErrorType[];
}
